/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { isArrayNotEmpty } from "utils/empty-exists";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { SectionLinkCardsSectionItem } from "./section_item";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { isRichTextEmpty } from "cms/rich-text/richtext-utils";

const SectionLinkCardsComponentDisplay = () => {
    const { component } = useContext(ContentZoneContext);
    
    const title = component?.title;
    const description = component?.description;
    const cards = component?.cards || [];
    
    const hasContent = isArrayNotEmpty(cards);
    const noCardsMessage = "No cards have been added to this section yet.";
    
    return (
        <>
            <EmptyContentMessage
                hasContent={hasContent}
                component={component}
                message={noCardsMessage}
            />
            {hasContent &&
                <div className="simplicity-section-link-cards">
                    {title && (
                        <div className="simplicity-section-link-cards-title">
                            <h2>{title}</h2>
                        </div>
                    )}
                    
                    {!isRichTextEmpty(description) && (
                        <div className="simplicity-section-link-cards-description">
                            <RichTextPreview richtext={description} />
                        </div>
                    )}
                    
                    <div className="simplicity-section-link-cards-grid">
                        {cards.map((card, index) => {
                            return (
                                <SectionLinkCardsSectionItem
                                    key={index}
                                    card={card}
                                />
                            );
                        })}
                    </div>
                </div>
            }
        </>
    );
};

SectionLinkCardsComponentDisplay.displayName = "SectionLinkCardsComponentDisplay";
export { SectionLinkCardsComponentDisplay };
